
import { Component, Vue } from "vue-property-decorator";
import { actions, FacilityProfile } from "@/survey";
import FileUploadInput from "@/components/FileUploadInput.vue";
import InputWithLabel from "@/components/InputWithLabel.vue";
import { email, required } from "vuelidate/lib/validators";
import store from "@/store";
import { validatePasswordIf, validatePasswordMinLengthIf, validatePasswordPatternIf, validatePhone } from "@/validators";

@Component({
  components: { InputWithLabel, FileUploadInput: FileUploadInput },
  validations: {
    user: {
      password: {
        validatePasswordIf,
        minLength: validatePasswordMinLengthIf(store.state.settings.passwordLength),
        letters: validatePasswordPatternIf(/[a-z]+/),
        LETTERS: validatePasswordPatternIf(/[A-Z]+/),
        numbers: validatePasswordPatternIf(/[0-9]+/),
        special: validatePasswordPatternIf(/[!@#$%^&*/?]+/)
      },
      username: { required },
      firstName: { required },
      lastName: { required },
      facilityProfile: { required },
      email: { required, email },
      phone: { validatePhone }
    }
  }
})
export default class AdminUserForm extends Vue {
  get facilityProfileOptions() {
    const opts: { value: number, text: string }[] = [];
    this.$store.state.facilityProfiles.forEach(function(fp: FacilityProfile) {
      opts.push({ value: fp.id!!, text: fp.name });
    });
    return opts;
  }

  get oauthEnabled(){
    return this.$store.state.oauth['oauth.enabled'] === 'true'
  }

  get ssoOnly() {
    return !this.$data.user.localLoginEnabled;
  }

  set ssoOnly(value: boolean) {
    this.$data.user.localLoginEnabled = !value;
    if (value) {
      this.$data.user.password = "";
      this.$data.user.needsPasswordChange = false;
      this.$data.user.neverExpires = true;
    }
  }

  data() {
    try {
      const userId = parseInt(this.$route.params.id);
      for (const user of this.$store.state.users) {
        if (user.id === userId) {
          return {
            user: { ...user, password: "" },
            userImage: null
          };
        }
      }
      throw "Cannot find user for id " + userId;
    } catch (e) {
      return {
        user: {
          id: null,
          username: "",
          password: "",
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          dateCreated: new Date().getTime(),
          active: true,
          create: true,
          edit: false,
          view: true,
          delete: false,
          export: false,
          admin: false,
          localLoginEnabled: true,
          notes: "",
          facilityProfile: 1,
          needsPasswordChange: true,
          neverExpires: false
        },
        userImage: null
      };
    }
  }

  onSubmit() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      alert("Cannot save record, see form for error messages");
      return;
    }

    if (!this.$data.user.localLoginEnabled) {
      this.$data.user.password = "";
      this.$data.user.needsPasswordChange = false;
      this.$data.user.neverExpires = true;
    }

    this.$store.dispatch(actions.CREATE_OR_UPDATE_USER, {
      toSave: this.$data.user,
      image: this.$data.userImage,
      success: () => this.$router.push("/admin/users")
    });
  }

  onCancel() {
    this.$router.push("/admin/users");
  }
}
